import { render, staticRenderFns } from "./ModalEditVideo.vue?vue&type=template&id=72a8932a&"
import script from "./ModalEditVideo.vue?vue&type=script&lang=js&"
export * from "./ModalEditVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports